



























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { validationMixin } from 'vuelidate';

import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import { designStore } from '@/store/store';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { findZr } from '@/modules/design/lib/calculations/calculationUtils';
import { between, minValue, required } from 'vuelidate/lib/validators';
import { Route } from 'vue-router';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import { createPorousValidations } from '@/modules/design/lib/validations/porous';


@Component({
  components: {
    ValidatedInputPageWrapper,
    PxDropdown,
    PxNumberInput,
    InputPageWrapper,
  },
  // validations:{
  //   deltaServicability: {
  //     between: between(-5, 0)
  //   },
  //   scenario: {
  //     designPeriod_years: {
  //       required,
  //       minValue: minValue(0)
  //     },
  //     reliabilityLevel: {
  //       required
  //     },
  //     standardError: {
  //       required,
  //       between: between(0, 1)
  //     },
  //     initialServicability : {
  //       required,
  //       between: between(0, 5)
  //     },
  //     terminalServicability :{
  //       required,
  //       between: between(0, 5)
  //     },
  //   }
  // }
})
export default class PorousDesignParameters extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentPorous;
  }

  get scenarioImperial() {
    return designStore.currentPorousImperial;
  }

  validations() {
    return createPorousValidations(this.scenarioImperial);
  }

  save() {
    this.sync();
    designStore.saveCurrentPorousScenario();
  }

  sync() {
    designStore.setCurrentPorousScenario(this.scenario);
  }

  beforeRouteLeave(to: Route, from: Route, next:Function) {
    this.save();
    next();
  }

  reliabilityOptions: { value: number, text: string }[] = [
    { value: 50, text: '50%' },
    { value: 60, text: '60%' },
    { value: 70, text: '70%' },
    { value: 75, text: '75%' },
    { value: 80, text: '80%' },
    { value: 85, text: '85%' },
    { value: 90, text: '90%' },
    { value: 95, text: '95%' },
    { value: 99, text: '99%' },
  ];

  get zr() {
    const zr = findZr(this.scenario.reliabilityLevel || 50);
    console.log(zr);
    return zr;
  }

  get deltaServiceability(): number | null {
    if (this.scenario.terminalServiceability !== null && this.scenario.initialServiceability !== null) {
      this.scenario.deltaServiceability = this.scenario.initialServiceability - this.scenario.terminalServiceability;
      // return Math.abs(this.scenario.deltaServiceability)
      return this.scenario.deltaServiceability;
    }
    return null;
  }
// get deltaServicability(): number | null {
//   if (this.scenario.terminalServicability !== null && this.scenario.initialServicability !== null) {
//     return Number((this.scenario.terminalServicability - this.scenario.initialServicability).toFixed(3))
//   }
//   return null
// }
}
